import {isDefined} from '@/utils/typeGuards/isDefined';

export function arrayIsEmpty<T>(value?: T[]): boolean {
    if (!isDefined(value)) {
        return true;
    }
    return value.length === 0;
}
